import React from 'react';

export const LabelInput = ({ value }) => {
  return <label className="form-control-label">{value}</label>;
};
